import { useMemo } from 'react';
import { ApiClient, EntityCollection } from '../api/content';
import { createPageQuery, unwrap } from './factory';
import { Event } from './useEventsQuery';

function getEventDetails(id: string) {
  return ApiClient.get<EntityCollection<Event>>(`/events`, {
    params: {
      filters: {
        slug: {
          $eq: id,
        },
      },
      populate: 'deep',
    },
  });
}

export function getEventDetailsQuery(id: string) {
  return createPageQuery({
    queryKey: ['events', id],
    queryFn: unwrap(() => getEventDetails(id)),
  });
}

export function useEventDetailsQuery(id: string) {
  const { useQuery } = useMemo(() => getEventDetailsQuery(id), [id]);

  return useQuery();
}
